import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import { DayPicker } from 'react-day-picker';
import { cn } from '@/lib/utils';
import { buttonVariants } from '@/components/ui/button';

function Calendar({
  className,
  classNames,
  showOutsideDays = true,
  ...props
}) {
  return (
    <DayPicker
      showOutsideDays={showOutsideDays}
      className={cn('p-3 transition-all duration-500 ease-in-out', className)}
      classNames={{
        months: 'flex flex-col sm:flex-row space-y-4 sm:space-x-4 sm:space-y-0',
        month: 'space-y-4',
        caption: 'flex justify-center pt-1 relative items-center',
        caption_label: 'text-sm font-semibold text-foreground dark:text-white',
        nav: 'space-x-1 flex items-center',
        nav_button: cn(
          buttonVariants({ variant: 'outline' }),
          'h-7 w-7 bg-transparent p-0 opacity-50 hover:opacity-100 transition-opacity'
        ),
        nav_button_previous: 'absolute left-1',
        nav_button_next: 'absolute right-1',
        table: 'w-full border-collapse space-y-1',
        head_row: 'flex',
        head_cell:
          'text-muted-foreground rounded-md w-9 font-medium text-[0.8rem] uppercase tracking-wide',
        row: 'flex w-full mt-2',
        cell: 'h-9 w-9 text-center text-sm p-0 relative transition-all duration-300 ease-in-out',
        day: cn(
  buttonVariants({ variant: 'ghost' }),
  'h-9 w-9 p-0 font-normal aria-selected:opacity-100',
  'text-foreground dark:text-white',
  'transition-colors duration-300 hover:bg-accent hover:text-white focus-visible:ring-2 focus-visible:ring-primary/50'
),

        day_selected:
          'bg-primary text-white hover:bg-primary hover:text-white focus:bg-primary focus:text-white ring-2 ring-primary/50 scale-[1.05] transition-transform',
        day_today:
          'bg-background text-primary font-bold border border-primary dark:bg-neutral-900 dark:text-primary',
        day_outside:
          'text-muted-foreground opacity-40 dark:opacity-30',
        day_disabled:
          'text-muted-foreground opacity-30 cursor-not-allowed',
        day_range_middle:
          'aria-selected:bg-accent aria-selected:text-accent-foreground',
        day_range_end: 'day-range-end',
        day_hidden: 'invisible',
        ...classNames,
      }}
      components={{
        IconLeft: ({ ...props }) => <ChevronLeft className="h-4 w-4 text-muted-foreground" />,
        IconRight: ({ ...props }) => <ChevronRight className="h-4 w-4 text-muted-foreground" />,
      }}
      {...props}
    />
  );
}

Calendar.displayName = 'Calendar';

export { Calendar };
